module.exports = __webpack_public_path__ + "static/img/tt2.86e49245.png";